import { keepPreviousData, useQuery } from '@tanstack/react-query';
import axiosInstance from '../../../lib/axios';
import type {
  AdminVideoJobDetail,
  AdminVideoJobFilters,
  AdminVideoJobPage,
  VideoServiceHealth,
} from './types';

const BASE = '/v1/admin/generate-video';

export const generateVideoKeys = {
  all: ['admin-generate-video'] as const,
  health: () => [...generateVideoKeys.all, 'health'] as const,
  jobs: (filters: AdminVideoJobFilters) => [...generateVideoKeys.all, 'jobs', filters] as const,
  job: (jobId: string) => [...generateVideoKeys.all, 'job', jobId] as const,
};

export const useGenerateVideoHealth = (enabled = true) =>
  useQuery({
    queryKey: generateVideoKeys.health(),
    queryFn: async (): Promise<VideoServiceHealth> =>
      (await axiosInstance.get(`${BASE}/health`)).data.data,
    enabled,
  });

export const useAdminVideoJobs = (filters: AdminVideoJobFilters) =>
  useQuery({
    queryKey: generateVideoKeys.jobs(filters),
    queryFn: async (): Promise<AdminVideoJobPage> => {
      const { data } = await axiosInstance.get(`${BASE}/jobs`, { params: filters });
      return { data: data.data, pagination: data.pagination };
    },
    placeholderData: keepPreviousData,
  });

export const useAdminVideoJob = (jobId: string | null) =>
  useQuery({
    queryKey: generateVideoKeys.job(jobId ?? ''),
    queryFn: async (): Promise<AdminVideoJobDetail> =>
      (await axiosInstance.get(`${BASE}/jobs/${encodeURIComponent(jobId ?? '')}`)).data.data,
    enabled: Boolean(jobId),
  });
